import {VendorList} from '../service/vendor-list'

// @ts-ignore
import {ConsentString} from 'consent-string'

export const getConsentData = (vendorList: VendorList): ConsentString => {
  const consentData = new ConsentString()
  consentData.setGlobalVendorList(vendorList)
  consentData.setCmpId(27)
  consentData.setCmpVersion(1)
  consentData.setConsentScreen(1)
  consentData.setConsentLanguage('en')
  return consentData
}
